import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'convex/react'
import { api } from '../../../convex/_generated/api'
import { useAuth0 } from '../../hooks/useAuth0'
import { UserAvatar } from './UserAvatar'
import { UserDropdown } from './UserDropdown'

export function Header() {
  const navigate = useNavigate()
  const { user, logout } = useAuth0()
  const settings = useQuery(api.settings.getSettings)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const headerStyles: React.CSSProperties = {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(8px)',
    borderBottom: '1px solid #f3f4f6',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  }

  const containerStyles: React.CSSProperties = {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }

  const logoContainerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    cursor: 'pointer',
  }

  const logoImageStyles: React.CSSProperties = {
    height: '40px',
    width: '40px',
    objectFit: 'contain',
  }

  const logoTextStyles: React.CSSProperties = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#111827',
  }

  const avatarContainerStyles: React.CSSProperties = {
    position: 'relative',
  }

  // Get display name from settings or Auth0 user
  const displayName = settings?.caregiver?.name || user?.name || user?.email || 'User'
  const displayEmail = user?.email || ''
  const photoUrl = settings?.caregiver?.profilePhotoUrl

  return (
    <header style={headerStyles}>
      <div style={containerStyles}>
        <div
          style={logoContainerStyles}
          onClick={() => navigate('/dashboard')}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              navigate('/dashboard')
            }
          }}
        >
          <img src="/favicon.png" alt="Little Sister Logo" style={logoImageStyles} />
          <span style={logoTextStyles}>Little Sister</span>
        </div>

        <div style={avatarContainerStyles}>
          <UserAvatar
            name={displayName}
            photoUrl={photoUrl}
            size="md"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          />
          <UserDropdown
            isOpen={isDropdownOpen}
            onClose={() => setIsDropdownOpen(false)}
            userName={displayName}
            userEmail={displayEmail}
            onSettingsClick={() => navigate('/settings')}
            onLogoutClick={() => logout()}
          />
        </div>
      </div>
    </header>
  )
}
